//noinspection TypeScriptCheckImport
import {TranslateUtils} from '../../index';

let translations = [
    require('./common.json'),
    require('./login.json'),
    require('./pool.json'),
    require('./liquidity_accounts.json'),
    require('./account.json'),
    require('./modal.json'),
    require('./transfers.json'),
    require('./outer-payments.json'),
    require('./system-payments.json'),
    require('./customers.json'),
    require('./applications.json'),
    require('./cards.json'),
    require('./configuration.json'),
    require('./space.json'),
    require('./filter.json'),
    require('./processing.json'),
    require('./reports.json'),
];

try {
    translations.push(require(`./vendor-translations/${VENDOR}.json`));
} catch (e) {
    translations.push(require('./vendor-translations/whitelabel.json'));
}

export const LOCALE = TranslateUtils.buildTranslatePack(translations);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/translate/translations/en/index.ts